import React from "react";

import { images } from "../../constants";
import "./Abstract.css";

const Abstract = () => (
  <div
    className="app__aboutus app__bg flex__center section__padding"
    id="about"
  >
    <div className="app__aboutus-content flex__center">
      <div className="app__author-content">
        <h1 className="headtext__cormorant">Abstract</h1>
        <p className="p__opensans_lower_case">
          The overall purpose of this investigation was to promote the slowing
          down of consumption, practice mindfulness regarding where one’s
          resources and materials come from, and to push back against fast paced
          production methods and systems such as that of Amazon or Blurb. The
          research project also investigated ways to make publishing more
          sustainable, by researching the practice of paper recycling in the
          city of Los Angeles, recycled paper making, the viability of a salt
          water (as opposed to fresh water) based paper production system, and
          the promotion of paper production education on the current sustainable
          changes being applied to the industry. This project also seeks to
          destigmatize the practice of self publishing through online platforms
          (which is already a viable sustainability solution) while also
          honoring the cultural heritage and history behind traditional book
          making, and the practice and art of craftsmanship in creating
          books–not only as a means to transfer information, but as stand-alone
          art-works to be treasured, admired, and made to last.
        </p>
      </div>
    </div>

    <div className="app__aboutus-content_knife flex__center">
      <img src={images.forest} alt="forest image from book" />
    </div>
  </div>
);

export default Abstract;
